"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiPaymentIntentResponseDto = void 0;
const swagger_1 = require("../../../../swagger-fake");
const class_validator_1 = require("class-validator");
const billing_api_payment_intent_dto_1 = require("./billing-api-payment-intent.dto");
/**
 * Платёжное намерение.
 * Содержит исчерпывающую информацию необходимую для открытия
 * банковской формы ввода данных карты (либо иного способа оплаты)
 * используемой в будущих платежах (без повторного ввода данных карты).
 */
class BillingApiPaymentIntentResponseDto extends billing_api_payment_intent_dto_1.BillingApiPaymentIntentDto {}
__decorate([(0, swagger_1.ApiProperty)({
  description: "Id плательщика",
  format: "uuid",
  type: String
}), (0, class_validator_1.IsUUID)(4), __metadata("design:type", String)], BillingApiPaymentIntentResponseDto.prototype, "customerId", void 0);
__decorate([(0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4), __metadata("design:type", Object)], BillingApiPaymentIntentResponseDto.prototype, "paymentMethodId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Url для оплаты",
  format: "uuid",
  type: String
}), (0, class_validator_1.IsUrl)(), __metadata("design:type", String)], BillingApiPaymentIntentResponseDto.prototype, "paymentUrl", void 0);
__decorate([(0, class_validator_1.IsUrl)(), __metadata("design:type", String)], BillingApiPaymentIntentResponseDto.prototype, "successUrl", void 0);
__decorate([(0, class_validator_1.IsUrl)(), __metadata("design:type", String)], BillingApiPaymentIntentResponseDto.prototype, "webHookUrl", void 0);
exports.BillingApiPaymentIntentResponseDto = BillingApiPaymentIntentResponseDto;
